import $ from 'jquery';
import {createApp} from 'vue';
import {createPinia} from 'pinia'
import Wishlist from './Components/Wishlist';
import Heart from "./Components/Heart";
import Persist from "./Persist";
import {useWishlistStore} from "./Stores/WishlistStore";

export const pinia = createPinia();
const app = createApp(Wishlist);
const persist = new Persist();

function updateHeartCounter(count) {
    const $counters = $('*[data-wishlist="count"]');
    $counters.addClass('d-none');
    if (count > 0) {
        $counters.text(count < 100 ? count : '99+');
        $counters.removeClass('d-none');
    }
}

pinia.use(({store}) => {
    if (store.$id === 'wishlist') {
        store.items = persist.load('wishlist', []);
        updateHeartCounter(store.items.length);
        store.$subscribe((event, state) => {
            persist.persist('wishlist', state.items);
            updateHeartCounter(state.items.length);
        });
    }
});

app.use(pinia);
app.mount('#wishlist');


$('*[data-heart]').each(function (e) {
    const type = $(this).attr('data-heart');
    let category = null;
    try {
        category = JSON.parse(this.dataset.heartCategory);
    } catch (e) {
    }
    const heart = createApp(Heart, {
        id: this.dataset.heartId,
        absolute: type === 'absolute',
        type: this.dataset.heartType,
        title: this.dataset.heartTitle,
        price: this.dataset.heartPrice,
        category: category,
        image: this.dataset.heartImage,
        url: this.dataset.heartUrl,
        icon: this.dataset.heartIcon,
    });
    heart.use(pinia);
    heart.mount(this);
});

$('*[data-toggle="wishlist"]').on('click', function (ev) {
    ev.preventDefault();
    const wishlist = useWishlistStore();
    wishlist.toggle();
});
